import React from 'react';
import { Column, Row } from '../../../shared/components/Grid/Grid';
import { Field } from '../../../shared/components/Form';
import { t } from '../../../shared/components/l10n/l10n';
import AccountCombobox from '../../../shared/components/ui/AccountCombobox';

const VatColumn = ({ field, fieldIndex }) => (
    <Column>
        {field && (
            <Field.Combobox
                as={AccountCombobox}
                name={`accountingRules.countrySpecificVatRuleItems[${fieldIndex}].accountNumber`}
                label={t(field.textId)}
            />
        )}
    </Column>
);

export default function CountrySpecificVatTable({ fields, columnsCount, startIndex, endIndex }) {
    const rowsCount = (endIndex - startIndex + 1) / columnsCount;
    return (
        <div role="table" className="yt-table">
            <div role="rowgroup" className="yt-table__body">
                {[...Array(rowsCount)].map((_, rowIndex) => {
                    return (
                        <Row>
                            {[...Array(columnsCount)].map((_, colIndex) => {
                                const fieldIndex = startIndex + (rowIndex * columnsCount + colIndex);
                                const field = fields.value[fieldIndex];
                                return <VatColumn field={field} fieldIndex={fieldIndex} />;
                            })}
                        </Row>
                    );
                })}
            </div>
        </div>
    );
}
